import { render, staticRenderFns } from "./markdown.vue?vue&type=template&id=23719ae4"
import script from "./markdown.vue?vue&type=script&lang=js"
export * from "./markdown.vue?vue&type=script&lang=js"
import style0 from "./markdown.vue?vue&type=style&index=0&id=23719ae4&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports